import * as Scrivito from "scrivito";

const AlbumGalleryWidget = Scrivito.provideWidgetClass("AlbumGalleryWidget", {
  attributes: {
    images: ["referencelist", { only: ["Image"] }],
  },
});

export default AlbumGalleryWidget;
